import { selectBreakpointToken } from './selectBreakpointToken'

type AppliedTokens = Record<string, unknown>

export const applyTokens = (
  tokenConfig: Record<string, unknown>,
  breakpoint: number,
  tokens: Record<string, unknown>
): AppliedTokens => {
  return Object.entries(tokens).reduce<AppliedTokens>((memo, [tokenKey, tokenValue]) => {
    const tokenConfigValue = tokenConfig[tokenKey]

    if (!tokenConfigValue) {
      memo[tokenKey] = selectBreakpointToken(breakpoint, tokenValue)

      return memo
    }

    if (['string', 'number'].includes(typeof tokenConfigValue)) {
      memo[tokenKey] = selectBreakpointToken(breakpoint, tokenConfigValue)

      return memo
    }

    const config = tokenConfigValue as Record<string, unknown>
    switch (typeof tokenValue) {
      case 'number':
        memo[tokenKey] = selectBreakpointToken(
          breakpoint,
          config[tokenValue] || tokenValue
        )

        return memo
      case 'string':
        if (tokenValue.includes('.')) {
          const [tokenValueKey, tokenValueLookup] = tokenValue.split('.')

          memo[tokenKey] = selectBreakpointToken(
            breakpoint,
            config[tokenValueKey]
              ? (config[tokenValueKey] as Record<string, unknown>)[tokenValueLookup]
              : tokenValue
          )

          return memo
        } else {
          memo[tokenKey] = selectBreakpointToken(
            breakpoint,
            config[tokenValue] || tokenValue
          )

          return memo
        }
    }

    // TODO: Account for token selection '.' notation
    if (Array.isArray(tokenValue)) {
      const breakpointValue = selectBreakpointToken(breakpoint, tokenValue)

      memo[tokenKey] = (tokenConfigValue as Record<string, unknown>)[breakpointValue as string] || breakpointValue

      return memo
    }

    console.warn('No style tokens applied', tokenKey, tokenValue)

    return memo
  }, {})
}
